// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"main": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(default\-webpack_sharing_consume_default_(angular_(c(dk_(co(ercion_angular_cdk_coercion|llections_angular_cdk_collections)|a11y_angular_cdk_a11y|bidi_angular_cdk_bidi|keycodes_angular_cdk_keycodes|platform_angular_cdk_platform|portal_angular_cdk_portal|scrolling_angular_cdk_scrolling|stepper_angular_cdk_stepper\-webpack_shari\-422b25)|o(mmon_(angular_common|http_angular_common_http)|re_(angular_core|rxjs\-interop_angular_core_rxjs\-interop)))|(platform\-browser_angular_platform\-brows|router_angular_rout)er|animations_angular_animations|forms_angular_forms|material_core_angular_material_core)|ng(x\-(bootstrap_(chronos_ngx\-bootstrap_chronos\-webpack_s\-be08ef|component\-loader_ngx\-bootstrap_componen\-151866|mini\-ngrx_ngx\-bootstrap_mini\-ngrx|positioning_ngx\-bootstrap_positioning|utils_ngx\-bootstrap_utils)|device\-detector_ngx\-device\-detector)|\-bootstrap_ng\-bootstrap_ng\-bootstrap_ng\-bootstrap\-w\-a54953|\-idle_core_ng\-idle_core)|primeng_(b(a(se(_primeng_base|component_primeng_basecomponent)|dge_primeng_badge)|utton_primeng_button)|i(con(s_(arrowdown_primeng_icons_arrowdown\-webpa\-3edac1|baseicon_primeng_icons_baseicon|primeng_icons)|field_primeng_iconfield\-webpack_sharing_c\-5d982b)|nput(number_primeng_inputnumber\-webpack_shari\-e4fa7b|text_primeng_inputtext))|to(gglebutton_primeng_togglebutton|oltip_primeng_tooltip)|(datepicker_primeng_datepicke|paginator_primeng_paginato|scroller_primeng_scrolle)r|(ripple_primeng_ripp|usestyle_primeng_usesty)le|api_primeng_api|autofocus_primeng_autofocus|checkbox_primeng_checkbox|config_primeng_config|dom_primeng_dom|utils_primeng_utils)|rxjs_(operators_rxjs_operator|rxj)s|ov\-workspace\-ui_ov\-components_ov\-workspace\-ui_ov\-comp\-40c3a6)|webpack_sharing_consume_default_(angular_animations_browser_angular_animations_browser|echarts_echarts))$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkov_physician_solution_ui"] = self["webpackChunkov_physician_solution_ui"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));